module.exports = __webpack_public_path__ + "static/img/team1.ca380e4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/topImg/team1.jpg
// module id = 6cqv
// module chunks = 9